@if (this.currentCompanyStore.loaded()) {
  <dw-grid-list-page
    [title]="'Doc::Menu:CustomerInvoices' | abpLocalization"
    [activeView]="agGrid.activeView"
    (createAction)="createEntity()"
    [createActionLabel]="'::Add'"
    (deleteAction)="deleteEntities()"
    [enableExportBtn]="enableExport"
    [enableDeleteBtn]="enableDelete"
    (exportAction)="agGrid.export()"
    [toolbarActions]="toolbarActions()"
    [hasQuickSearch]="true"
  >
    <dw-grid-ag-grid
      [columnDefs]="columns"
      [datasource]="datasource"
      (rowClicked)="rowClicked($event)"
      [(selectedRows)]="selectedEntities"
      (selectedRowsClicked)="selectedRowsClicked($event)"
      #agGrid
      [context]="GoliathDocumentEntityNames.CustomerInvoice.shortName"
    >
    </dw-grid-ag-grid>
  </dw-grid-list-page>
}
